/**
 * Cikk-figyelő (blog view analytics) kizárások.
 *
 * Csak a valódi olvasókat számoljuk: a tudástár listából / belső linkről
 * érkező kattintásokat és a külső (pl. Google) látogatókat. Az admin
 * felületről megnyitott cikkek NEM kerülnek a statisztikába.
 */
const ADMIN_KEY_STORAGE = 'orosz_admin_key_v1';
const ADMIN_VISIT_FLAG = 'oc_admin_visit_v1';

const safeLocal = (key) => {
  try { return window.localStorage.getItem(key); } catch { return null; }
};

export const markAdminVisit = () => {
  try { window.sessionStorage.setItem(ADMIN_VISIT_FLAG, '1'); } catch { /* private mode */ }
};

const cameFromAdminReferrer = () => {
  const ref = document.referrer || '';
  if (!ref) return false;
  try {
    const url = new URL(ref);
    return url.origin === window.location.origin && url.pathname.startsWith('/admin');
  } catch {
    return false;
  }
};

export const shouldSkipBlogTracking = () => {
  if (typeof window === 'undefined') return true;
  // 1. Admin kulcs van a böngészőben → ez az én gépem/sessionöm.
  if (safeLocal(ADMIN_KEY_STORAGE)) return true;
  // 2. Ebben a tabban/sessionben megnyílt egy /admin oldal (SPA navigáció).
  try {
    if (window.sessionStorage.getItem(ADMIN_VISIT_FLAG) === '1') return true;
  } catch { /* private mode */ }
  // 3. Teljes újratöltés / új tab közvetlenül egy admin oldalról.
  if (cameFromAdminReferrer()) return true;
  // 4. Explicit előnézeti linkek.
  const params = new URLSearchParams(window.location.search);
  if (['preview', 'admin', 'no_track'].some((p) => params.get(p) === '1')) return true;
  return false;
};
